import { EmptyComponentWithDataTestId } from '@app/components/EmptyComponentWithDataTestId/EmptyComponentWithDataTestId';

export { EmptyComponentWithDataTestId };
